import React, { forwardRef } from 'react';

const UnBookmarked = forwardRef( ( props, ref ) => (
	<svg
		ref={ ref }
		style={ { enableBackground: 'new 0 0 512 512' } }
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 512 512"
		{ ...props }
	>
		<path d="M78.377 0v510.536l183.308-143.085L433.622 512h.001V0H78.377zm325.365 447.842L262.385 329.001 108.259 449.306V29.881h295.483v417.961z" />
	</svg>
) );

UnBookmarked.displayName = 'UnBookmarked';

export default UnBookmarked;
